import { Box } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import React from "react";
import { Route, BrowserRouter as Router, Routes, useLocation, useNavigate } from 'react-router-dom';
import { aboutData, aboutHeading, aboutSubHeading, bannerData, bannerImages, COMPANY_INFO, contactButtonText, contactDetails, contactHeadingText, contactSubHeadingText, footerButtonText, footerData, formFields, navigationData, services, SOCIAL_LINKS, teamHeadingText, teamMembers } from "./assets/commonComponents/data";
import { aboutImage, companyLogo } from "./assets/commonComponents/images";
import AboutCard from "./components/aboutCard";
import AboutUsSection from "./components/aboutSection";
import BannerCard from "./components/bannerCard";
import ChatPopUp from "./components/chatPopUp";
import ContactForm from "./components/contactCard";
import Footer from "./components/footerCard";
import NavigationBar from "./components/navigationBar";
import ScrollToTop from "./components/ScrollToTop";
import FinancialServices from "./components/serviceCard";
import TeamSection from "./components/teamCard";
import ArticlePage from "./Pages/articlePage/ArticlePage";
import SidebarWithContent from "./Pages/documentPage/documentPage";
import BusinessToolCards from "./Util/UtilCategoryCard/UtilCategoryCard";
import UtilHeader from "./Util/UtilHeader/UtilHeader";
import MicaOIChat from "./components/MicaOIChat";
// import MicaOIChat from "./components/MicaOIChat.js";
// Wrapper component to pass navigate to components
console.log = () => {}
console.warn=()=>{}
console.error = () => {} 
function AppContent() {
  const isMobile = useMediaQuery("(max-width:768px)");
  const location=useLocation();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate(); // Hook for navigation

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

const handleScroll = (id) => {
    console.log("Scrolling to ID:", id);
    const element = document.getElementById(id);
    if (location.pathname !== "/" && id !== "knowledgebase") {
      // Navigate to homepage first
      navigate("/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const targetElement = document.getElementById(id);
        if (targetElement) {
          const yOffset = -80;
          const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          console.log("Element not found after navigation:", id);
        }
      }, 100); // Small delay to ensure DOM is updated
    } else if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      console.log("Element not found:", id);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box id="nav">
        {
          location.pathname !="/micaoi" &&

        <NavigationBar
          logo={companyLogo}
          isMobile={isMobile}
          drawerOpen={drawerOpen}
          toggleDrawer={toggleDrawer}
          handleScroll={handleScroll}
          navigationData={navigationData}
        />
        }
        {
          location.pathname!="/" && location.pathname!="/micaoi" &&

         <UtilHeader/>
        }
      </Box>
       <ScrollToTop/>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Box id="home">
                <BannerCard bannerImages={bannerImages} bannerData={bannerData} />
              </Box>
              <Box sx={{ marginTop: "5%" }}>
                <AboutCard data={services} />
              </Box>
              <Box id="about">
                <AboutUsSection
                  image={aboutImage}
                  headingText={aboutHeading}
                  subHeadingText={aboutSubHeading}
                  data={aboutData}
                  isMobile={isMobile}
                />
              </Box>
              <Box id="service">
                <FinancialServices isMobile={isMobile} />
              </Box>
              <Box id="team">
                <TeamSection data={teamMembers} headingText={teamHeadingText} />
              </Box>
              <Box id="contact">
                <ContactForm
                  details={contactDetails}
                  formData={formFields}
                  headingText={contactHeadingText}
                  subHeadingText={contactSubHeadingText}
                  buttonText={contactButtonText}
                />
              </Box>
             
            </>
          }
        />
       <Route path="/micaoi" element={<ChatPopUp />} />
        <Route path="/knowledgebase" element={<BusinessToolCards/>} />
         <Route path="/knowledgebase/article/:search/:id" element={<ArticlePage/>}/>
          <Route path="/knowledgebase/document/:recordid" element={<SidebarWithContent />} />
      </Routes>
      <Box>
        {
          location.pathname!=="/micaoi" &&

        <Footer
          data={footerData}
          buttonText={footerButtonText}
          companyInfo={COMPANY_INFO}
          mediaData={SOCIAL_LINKS}
          handleScroll={handleScroll}
        />
        }
        {
          location.pathname!=="/micaoi" &&

        <ChatPopUp />
        }
      
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;